<template>

    <div id="big-sereen">
        <div class="big-sereen-container">
            <img src="@/assets/img/jsc.png" style="height:1080px; width: 1920px; position: absolute; " alt="">
            <img src="@/assets/img/Group3911.png" style="height:1080px; width: 1920px; position: absolute; " alt="">

            <div class="header text-center text-2xl pt-5 animate-pulse relative">
                <!-- <span >综试区指数大数据展示</span> -->
                <span>跨境电商数据驾驶仓大屏</span>
                <!-- <i v-if="!fullShow" @click="openFull"
                class="el-icon-full-screen inline  float-right text-3xl cursor-pointer" style="color:#264277;"></i>
            <i  v-else @click="openFull" class="el-icon-copy-document inline  float-right text-3xl cursor-pointer"
                style="color:#264277;"></i> -->

                <span class="absolute right-14 top-8 cursor-pointer">
                    <img v-if="!fullShow" @click="openFull" src="../../assets/img/icon-openfullscreen.png"
                        class="inline  float-right mr-2" alt="">
                    <img v-else @click="openFull" src="../../assets/img/icon-exitfullscreen.png"
                        class="inline  float-right mr-2" alt="">
                </span>

            </div>

            <div class="body flex ">

                <div class="left ">

                    <div class="">
                        <!-- 区域销售占比 -->
                        <header class="k-header animate-pulse">
                            北海市当年进口总额

                        </header>
                        <div class="x-border l-1">
                            <!-- <div style=" color: #9FB7DF;    position: fixed;left: 70px;top:180px;">综试区出口商品销往到各国家的占比情况</div> -->
                            <!-- <Piechart :intervalRefreshDate="5000"></Piechart> -->
                            <!-- <AAA></AAA> -->
                            <ImportTotal v-if="pageData" :data="pageData"></ImportTotal>
                        </div>
                    </div>

                    <div class="mt-6">
                        <!-- 跨境电商企业数量 -->
                        <header class=" k-header animate-pulse">
                            北海市各区跨境电商企业数量
                        </header>
                        <div class="x-border l-2">
                            <!-- <Pillar :intervalRefreshDate="6000"></Pillar> -->
                            <Ranking2 />
                        </div>
                    </div>


                    <div class="mt-6">
                        <!-- 跨境电商企业数量 -->
                        <header class=" k-header animate-pulse">
                            北海市各区跨境电商企业占比
                        </header>
                        <div class="x-border l-2 overflow-hidden">
                            <EcommerceEnterpriseRatio />
                            <!-- <Pillar :intervalRefreshDate="6000"></Pillar> -->
                        </div>
                    </div>

                </div>

                <div class="center">

                    <div class="c-1">
                        <Map2></Map2>
                        <!-- <Map></Map> -->

                    </div>

                    <div class="mt-6">
                        <header class="k-header-max animate-pulse">
                            北海市过去12个月进口总额同比数据
                        </header>
                        <div class="c-2 x-border overflow-hidden">
                            <!-- <Ranking /> -->
                            <ImportTotalYoYLast12Months />
                        </div>
                    </div>
                </div>

                <div class="right">
                    <div>
                        <!-- 平台数据占比 -->
                        <header class=" k-header animate-pulse">
                            北海市当年进出口总额
                        </header>
                        <div class="r-1 x-border">
                            <!-- <RingDiagram :intervalRefreshDate="7000"></RingDiagram> -->
                            <CurrentYearImportExportTotal v-if="pageData" :data="pageData" />
                        </div>

                    </div>
                    <div class="mt-6">
                        <header class=" k-header animate-pulse">
                            北海市跨境电商企业总数
                        </header>

                        <div class="r-2 x-border">
                            <!-- <RingDiagram :intervalRefreshDate="7000"></RingDiagram> -->
                            <EcommerceEnterpriseTotal />
                        </div>

                    </div>

                    <div class="mt-6">
                        <header class=" k-header animate-pulse">
                            北海市过去12个月出口总额
                        </header>
                        <div class="r-2 x-border">
                            <!-- <RingDiagram :intervalRefreshDate="7000"></RingDiagram> -->
                            <ExportTotalLast12Months />
                        </div>

                    </div>
                </div>

            </div>

        </div>
    </div>
</template>

<script>
//区域销售占比图
import Piechart from "./components/Piechart/index.vue";
import Pillar from "./components/Pillar/index.vue";
import HorizontalPillar from "./components/HorizontalPillar/index.vue";
import RingDiagram from "./components/RingDiagram/index.vue";
//综试区发展能级指数
import Ranking from "./components/Ranking/index.vue";
//地图
// import Map from "./components/Map/index.vue";
import Map2 from "./components/Map2/index.vue";



import EcommerceEnterpriseRatio from "./components/EcommerceEnterpriseRatio"


import Ranking2 from "./components/Ranking2/index.vue";

import ImportTotal from './components/ImportTotal'

import CurrentYearImportExportTotal from './components/CurrentYearImportExportTotal'

import EcommerceEnterpriseTotal from './components/EcommerceEnterpriseTotal'

import ExportTotalLast12Months from './components/ExportTotalLast12Months'

import ImportTotalYoYLast12Months from './components/ImportTotalYoYLast12Months'

import { lsdRegionTradeStatIndex, lsdRegionTradeStatPageQuery ,cloudLSDPermissionsLogout } from "@/api/home";
export default {
    name: "",
    components: {Map2 ,Piechart, Pillar, HorizontalPillar, RingDiagram, Ranking, Map, EcommerceEnterpriseRatio, Ranking2, ImportTotal, CurrentYearImportExportTotal, EcommerceEnterpriseTotal, ExportTotalLast12Months, ImportTotalYoYLast12Months },
    props: {},
    data() {
        return {
            fullShow: false,
            pageData: undefined,
        };
    },
    watch: {},
    computed: {},
    methods: {
      async  out(){
           await cloudLSDPermissionsLogout()
        },
        async initData() {
            try {
                //获取当前年份 YYYY
                const year = new Date().getFullYear()
                const res = await lsdRegionTradeStatIndex({ queryType: 'CURRENT_YEAR' ,year: year});
                this.pageData = res.data[0]
            } catch (e) {
                
                
            }
        },
        openFull() {
            if (this.fullShow) {
                this.fullShow = false
                document.exitFullscreen()
                this.$message.success("退出全屏")
            } else {
                this.fullShow = true
                document.documentElement.requestFullscreen()
                this.$message.success("进入全屏")
            }

        }
    },
    created() { },
    async mounted() {
        await this.initData();


    }
}
</script>
<style lang="scss" scoped>
#big-sereen {
    position: relative;
    margin: auto;
    color: #fff;
    display: flex;
    // align-items: center;
    height: 100%;
    width: 1920px;
    // align-items: center;
    // background-color: #181b24;

    .big-sereen-container {
        // width: 100%;

        width: 1920px;
        height: 1080px;
        // background-image: url(@/assets/img/Group3911.png) ;
        background-size: 100%;
        background-repeat: no-repeat;

        margin: auto;

        .x-border {

            border-radius: 8px;
            border: 1px solid #203348;
            margin-top: 17px;
        }

        // height: 100%;
        // background-image: url(../../assets/img/bg.png);

        .header {
            // background-image: url(../../assets/img/top.png);
            background-size: 100%;
            // height: 113px;

            font-size: 47px;
            font-family: YouSheBiaoTiHei;
            font-weight: 400;
            color: #EFF8FC;
            // line-height: 41px;


        }

        .body {
            margin-top: 70px;
            position: relative;
            .k-header,
            .k-header-max {
                background-image: url(../../assets/img/min-title.png);
                background-size: 100% 100%;
                height: 36px;
                line-height: 35px;
                padding-left: 20px;
                color: #D9EAF5;
                font-weight: 400;
                font-family: YouSheBiaoTiHei;
                font-size: 20px;
            }

            .k-header-max {
                background-image: url(@/assets/img/Group3913.png);
                height: 34px;
                line-height: 34px;

            }

            .left {
                width: 434px;
                margin-left: 62px;

                .l-1 {
                    height: 223px;
                }

                .l-2 {
                    height: 223px;
                    overflow: hidden;
                }
            }

            .center {
                width: 807px;
                margin-left: 40px;

                .c-1 {
                    height: 578px;


                }

                .c-2 {
                    height: 223px;
                }

            }

            .right {
                // @apply ml-5;
                width: 473px;
                margin-left: 40px;

                .r-1 {
                    height: 223px;
                }

                .r-2 {
                    height: 223px;

                }
            }

        }
    }
}
</style>